import PageV2Comp from "../../components/page_v2/page_v2_comp";
import TermsOfService from "./components/terms_of_service_comp";

const TermsOfServicePage = () => {
  return (
    <PageV2Comp>
      <TermsOfService />
    </PageV2Comp>
  );
};
export default TermsOfServicePage;
